import React from "react";
import Pill from "../../ui/atoms/Pill";

export type AuditLogsResultType = "Success" | "Failed";

interface AuditLogsResultPillProps {
  value: AuditLogsResultType;
}

const AuditLogsResultPill: React.FC<AuditLogsResultPillProps> = ({ value }) => {
  return (
    <Pill
      className={`audit-logs-result-pill audit-logs-result-pill--${value.toLowerCase()}`}
    >
      {value}
    </Pill>
  );
};

export default AuditLogsResultPill;
